// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-bar-menu-common{height:55px;line-height:55px}.header-bar-menu-common .menu{display:flex}.header-bar-menu-common .menu .cell{padding:0 10px;font-size:16px}.header-bar-menu-common .menu .cell a{color:#333}", ""]);
// Exports
module.exports = exports;
